import { LookbookSettingsCriteriaForm, LookbookSettingsLayout } from '@app/components/lookbook/LookbookSettingsPage/components';
import { compiledPaths } from '@app/paths';
import { useLookbookDetails } from '@app/services/hooks/lookbook/useLookbookDetails';
import { useParams } from 'react-router-dom';

const LOOKBOOK_CRITERIA_FORM_NAME = 'lookbookSettingsCriteriaForm';

export const LookbookSettingsCriteriaPage = () => {
  const { lookbookId } = useParams<{ lookbookId: string }>();

  const { isLoading: isLoadingLookbookSettings } = useLookbookDetails({ lookbookId });

  return (
    <LookbookSettingsLayout
      lookbookId={lookbookId}
      formName={LOOKBOOK_CRITERIA_FORM_NAME}
      activePath={compiledPaths.LOOKBOOK_SINGLE_SETTINGS_CRITERIA({ lookbookId })}
      isDisabled={isLoadingLookbookSettings}
      hasActionButtons={false}
    >
      <LookbookSettingsCriteriaForm lookbookId={lookbookId} />
    </LookbookSettingsLayout>
  );
};
